import {useControllers} from '../../../../../../common/helpers/react/hooks/useControllers';
import {tWithHtml} from '../../../../../../common/helpers/react/text/tWithHtml';
import {DefaultTableCheckboxModeProps} from '../../../../common/components/table/DefaultTable';
import {SelectInput} from '@sabre/spark-react-core';
import {useState} from 'react';
import {Options} from '@sabre/spark-react-core/select-input/select-input.types';


export default function AddToGroupModal(props: DefaultTableCheckboxModeProps) {
    const [group, setGroup] = useState<string>('NEW_GROUP');
    const controllers = useControllers();
    const groups = controllers.groups;
    const dialog = controllers.dialog;

    const modal = dialog.getCurrentModal$().useState() ?? {};

    const groupsList: Options[] = groups.getAllGroups$().useState()?.map(it => {
        return {
            label: it.name,
            value: it.id
        };
    }) ?? [];

    modal.data = {
        groupId: group
    };

    return (
        <>
            <p>
                {tWithHtml('ADD_X_AGENTS_TO_GROUP', {number: props.checkedRows?.length ?? 0})}
            </p>
            <p>
                <SelectInput
                    options={[
                        {
                            label: '--Create new group --',
                            value: 'NEW_GROUP'
                        },
                        ...groupsList
                    ]}
                    value={group}
                    onChange={(e, value): void => {
                        setGroup(value);
                    }}
                />
            </p>
        </>
    );
}